export const MAX_RETRIES = 3;
export const TIMEOUT = 5000;

export const SERVER_ERROR = 'There was an error';
export const SERVER_401 = 'Not authorised';
export const SERVER_403 = 'Forbidden to access this resource';
export const SERVER_404 = 'Item not found on the server';



